import { Layout } from 'components/layout';
import { Container } from 'components/container';
import { IconWhatsapp } from 'components/icons/whatsapp';
import { IconTelegram } from 'components/icons/telegram';
import { IconEmail } from 'components/icons/email';
import { useLocale } from 'locale';
import { Header, Img, Link, Links, Subtitle, Title } from './styled';

export const SendData = () => {
  const locale = useLocale();

  return (
    <Layout>
      <Container>
        <Header>
          <Title>{locale.sendData.title}</Title>
          <Img
            src="https://gdb.rferl.org/01000000-0a00-0242-60d6-08dc95dfd633.png"
            alt={locale.sendData.title}
          />
          {locale.sendData.content}
        </Header>

        <Subtitle>{locale.sendData.subtitle}</Subtitle>

        <Links>
          <Link href="" target="_blank" rel="noreferrer">
            <IconWhatsapp /> +420 724 971 539
          </Link>
          <Link href="https://t.me/ozodnews" target="_blank">
            <IconTelegram /> @ozodnews
          </Link>
          <Link href="mailto:ozodlikmail@gmail.com" target="_blank">
            <IconEmail /> ozodlikmail@gmail.com
          </Link>
        </Links>
      </Container>
    </Layout>
  );
};
